import { render, staticRenderFns } from "./AndroidRouter.vue?vue&type=template&id=40f524cf&scoped=true"
import script from "./AndroidRouter.vue?vue&type=script&lang=js"
export * from "./AndroidRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f524cf",
  null
  
)

export default component.exports